var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.showMap
        ? _c(
            "b-container",
            { staticClass: "mt-4" },
            [
              _vm.currentOffset === null
                ? _c(
                    "transition-group",
                    {
                      attrs: {
                        appear: "",
                        name: "listCustomTransition",
                        tag: "div"
                      }
                    },
                    [
                      _c("div", {
                        key: "searchPlaceHolder-nbAnnonces",
                        staticClass: "card-nb-annonces placeholder-nb-annonces",
                        class: { "placeholder-animated": _vm.isSearching }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          key: "searchPlaceHolder-cardAnnonces",
                          staticClass: "row row-cards-annonces"
                        },
                        [
                          _c("PlaceholderCardAnnonce", {
                            attrs: {
                              isAnimated: _vm.isSearching,
                              isGradient: false
                            }
                          }),
                          _vm._v(" "),
                          _c("PlaceholderCardAnnonce", {
                            attrs: {
                              isAnimated: _vm.isSearching,
                              isGradient: false,
                              customDisplayClass: "d-none d-sm-none d-md-block"
                            }
                          }),
                          _vm._v(" "),
                          _c("PlaceholderCardAnnonce", {
                            attrs: {
                              isAnimated: _vm.isSearching,
                              isGradient: false,
                              customDisplayClass:
                                "d-none d-sm-none d-md-none d-lg-block"
                            }
                          }),
                          _vm._v(" "),
                          _c("PlaceholderCardAnnonce", {
                            attrs: {
                              isAnimated: _vm.isSearching,
                              isGradient: true
                            }
                          }),
                          _vm._v(" "),
                          _c("PlaceholderCardAnnonce", {
                            attrs: {
                              isAnimated: _vm.isSearching,
                              isGradient: true,
                              customDisplayClass: "d-none d-sm-none d-md-block"
                            }
                          }),
                          _vm._v(" "),
                          _c("PlaceholderCardAnnonce", {
                            attrs: {
                              isAnimated: _vm.isSearching,
                              isGradient: true,
                              customDisplayClass:
                                "d-none d-sm-none d-md-none d-lg-block"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                : _c("div", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-between align-items-center"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _vm.canCreateSavedSearch && !_vm.savedSearchId
                              ? _c(
                                  "b-button",
                                  {
                                    staticClass:
                                      "mr-3 btn-create-saved-search d-flex align-items-center",
                                    on: { click: _vm.createSavedSearch }
                                  },
                                  [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(_vm.$t("saved.search.a.create"))
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass:
                                        "ph-custom ph-megaphone align-items-center ml-2"
                                    })
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.canCreateSavedSearch && _vm.savedSearchId
                              ? _c(
                                  "b-button",
                                  {
                                    staticClass:
                                      "mr-3 btn-delete-saved-search d-flex align-items-center",
                                    attrs: {
                                      id: "btn-delete-saved-search-id",
                                      variant: "btn-delete-saved-search"
                                    },
                                    on: { click: _vm.deleteSavedSearch }
                                  },
                                  [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(_vm.$t("saved.search.delete"))
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass:
                                        "ph-custom ph-megaphone align-items-center ml-2"
                                    })
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.canCreateSavedSearch
                              ? _c("i", {
                                  staticClass:
                                    "ph-custom ph-question mr-2 ph-custom-question",
                                  on: {
                                    click: function($event) {
                                      return _vm.$bvModal.show(
                                        "alert-info-modal"
                                      )
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.totalRows > 0
                              ? _c(
                                  "div",
                                  { staticClass: "card-nb-annonces h-100" },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.totalRows) +
                                        " " +
                                        _vm._s(
                                          _vm.totalRows > 1
                                            ? _vm.$t("Annonces")
                                            : _vm.$t("Annonce")
                                        ) +
                                        "\n          "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.totalRows > 0
                          ? _c(
                              "div",
                              {
                                staticClass: "sort-button",
                                on: {
                                  click: function($event) {
                                    return _vm.openFiltersModal("sort")
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "ph-custom ph-arrows-down-up"
                                })
                              ]
                            )
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row row-cards-annonces" },
                      [
                        _vm.annonces && _vm.annonces.length > 0
                          ? [
                              _vm._l(_vm.annonces, function(annonce) {
                                return _c(
                                  "transition-group",
                                  {
                                    key: annonce.serverId + "annonceCard",
                                    staticClass:
                                      "col-container-card-annonce col-12 col-sm-12 col-md-6 col-lg-4",
                                    attrs: {
                                      appear: "",
                                      name: "listCustomTransition",
                                      tag: "div"
                                    }
                                  },
                                  [
                                    _c("annonce-card-image-left", {
                                      key: annonce.serverId,
                                      staticClass: "cursor-pointer",
                                      attrs: { annonce: annonce }
                                    })
                                  ],
                                  1
                                )
                              }),
                              _vm._v(" "),
                              _vm.nextOffset > 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-12 d-flex justify-content-center"
                                    },
                                    [
                                      !_vm.isSearching
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "see-more-button btn-primary",
                                              on: { click: _vm.addMoreAnnonces }
                                            },
                                            [
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(
                                                    _vm.isSearching
                                                      ? "..."
                                                      : _vm.$t(
                                                          "annonce.search.see.more"
                                                        )
                                                  ) +
                                                  "\n            "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isSearching
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "see-more-button-searching"
                                            },
                                            [
                                              _vm._v(
                                                "\n              ...\n            "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                : _vm._e()
                            ]
                          : _c(
                              "transition-group",
                              {
                                staticClass: "col-12 empty-state-container",
                                attrs: {
                                  appear: "",
                                  name: "listCustomTransition",
                                  tag: "div"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    key: "searchEmptyState-img",
                                    staticClass: "text-center mb-4"
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "empty-state-img",
                                      attrs: {
                                        src: require("@/assets/images/b122/img-confused.png"),
                                        alt: "no result"
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    key: "searchEmptyState-txt",
                                    staticClass: "text-center no-result-text"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "no-result-title mb-2" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("annonce.search.emptyTitle")
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "no-result-subtitle my-2"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("annonce.search.emptyText")
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                      ],
                      2
                    )
                  ]),
              _vm._v(" "),
              _c("div", { staticClass: "row justify-content-center" }, [
                _vm.currentOffset !== null
                  ? _c(
                      "div",
                      {
                        staticClass: "bold-text cursor-pointer",
                        attrs: { id: "mapButton" },
                        on: {
                          click: function($event) {
                            _vm.showMap = true
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("annonce.search.display.map")) +
                            "\n        "
                        ),
                        _c("i", {
                          staticClass: "ph-custom ph-map-trifold-bold ml-2"
                        })
                      ]
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showMap
        ? _c("AnnoncesMap", {
            staticClass: "annonces-map-div",
            attrs: { annonces: _vm.annonces, user: _vm.user },
            on: {
              hideMap: function($event) {
                _vm.showMap = false
              },
              searchFromCenterOfMap: _vm.searchAnnoncesFromCenterOfMap
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.filtersDataInitialValuesIsReady
        ? _c("filters-modal", {
            attrs: {
              filtersDataInitial: _vm.filtersDataInitialValues,
              fromBtnName: _vm.fromBtnName,
              needsToGetFiltersDataFromApp: _vm.needsToGetFiltersDataFromApp
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.canCreateSavedSearch
        ? _c("create-saved-search-modal", {
            attrs: {
              "filters-data": {
                researchText: this.researchText,
                address: this.address,
                researchSorting: this.researchSorting,
                locationRadius: this.locationRadius,
                latitude: this.latitude,
                longitude: this.longitude,
                vehicles: this.vehicles,
                brands: this.brands,
                models: this.models,
                modelFinishes: this.modelFinishes,
                colors: this.colors,
                energies: this.energies,
                minFiscalPower: this.minFiscalPower,
                maxFiscalPower: this.maxFiscalPower
              }
            },
            on: { "saved-search-created": _vm.savedSearchCreated }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.savedSearchId
        ? _c("delete-saved-search-modal", {
            attrs: {
              "selected-item": _vm.savedSearchId,
              "selected-item-name": _vm.savedSearchName,
              "begins-with-voyel": "",
              "item-to-string": "alerte",
              "the-article": "l'"
            },
            on: { didDeleteItem: _vm.didDeleteAlert }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("alert-info-modal")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-633a08e5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-633a08e5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/search/Search.vue
// module id = 3kko
// module chunks = 0